module.exports = __webpack_public_path__ + "img/DepositExpress.e9a9497.png";